import * as React from 'react';

var _path, _path2, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgExclamationShield = function SvgExclamationShield(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_19_423)",
        fillOpacity: 0.16,
        d: "M44.333 73.115a5 5 0 0 1-.615-.041 1.6 1.6 0 0 1-.483-.128q-9.633-3.33-15.934-12.432-6.3-9.102-6.301-20.251v-14.57q0-1.497.835-2.694a4.8 4.8 0 0 1 2.159-1.736l18.718-6.93Q43.564 14 44.333 14q.77 0 1.622.333l18.718 6.93q1.324.539 2.159 1.736t.835 2.693v14.57q0 11.151-6.302 20.252-6.3 9.102-15.855 12.438-.202.06-1.177.163"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_19_423)",
        d: "M40.351 41.391q.553 0 .909-.369.355-.368.355-.913V26.833q0-.481-.373-.882-.374-.4-.927-.4-.551 0-.908.4-.356.4-.356.882V40.11q0 .545.374.913.374.369.926.369m-.018 8.346q.852 0 1.33-.52.478-.519.478-1.288 0-.85-.478-1.361-.478-.51-1.33-.51-.85 0-1.33.51-.477.51-.477 1.33 0 .819.478 1.33.477.51 1.33.51m0 19.378a5 5 0 0 1-.615-.041 1.6 1.6 0 0 1-.483-.128q-9.633-3.33-15.934-12.432-6.3-9.102-6.301-20.251v-14.57q0-1.497.835-2.694a4.8 4.8 0 0 1 2.159-1.736l18.718-6.93Q39.564 10 40.333 10q.77 0 1.622.333l18.718 6.93q1.324.539 2.159 1.736t.835 2.693v14.57q0 11.151-6.302 20.252-6.3 9.102-15.855 12.438-.202.06-1.177.163m0-2.5q9.07-2.91 14.92-11.413t5.85-18.971V21.244a1.6 1.6 0 0 0-.257-.898 1.23 1.23 0 0 0-.705-.513l-18.846-7.012a2.8 2.8 0 0 0-.962-.193q-.449 0-.961.192l-18.846 7.013q-.45.129-.706.513a1.6 1.6 0 0 0-.256.898V36.23q0 10.468 5.85 18.97 5.848 8.505 14.92 11.414"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_19_423",
        x1: 21.487,
        x2: 67.017,
        y1: 43.557,
        y2: 43.557,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_19_423",
        x1: 17.487,
        x2: 63.017,
        y1: 39.557,
        y2: 39.557,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgExclamationShield as ReactComponent };
//# sourceMappingURL=ExclamationShield.svg.es.js.map
